import type {CommonProps} from './types';

const DownloadChartSmall = ({
  color = 'currentColor',
  size = 12,
  ...rest
}: CommonProps) => (
  <svg
    aria-hidden="true"
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M3.25 12a3.25 3.25 0 100-6.5 3.25 3.25 0 000 6.5zM2.02 8.9a.25.25 0 01.23-.15h.44a.06.06 0 00.06-.06V7.25a.5.5 0 011 0v1.44a.06.06 0 00.06.06h.44a.25.25 0 01.2.4l-1 1.26a.26.26 0 01-.4 0l-1-1.25a.25.25 0 01-.02-.27z"
      fill={color}
    />
    <path
      d="M10.5.3a1 1 0 00-.7-.3H4a1 1 0 00-1 1v3.64a.12.12 0 00.12.12 10.1 10.1 0 01.8.04.12.12 0 00.08-.12V1.25A.25.25 0 014.25 1h5.44c.07 0 .13.03.18.07l1.06 1.06c.04.05.07.11.07.18V9a.25.25 0 01-.25.25H7.32a.12.12 0 00-.12.1 3.98 3.98 0 01-.19.8.12.12 0 00.12.1H11a1 1 0 001-1V2.2a1 1 0 00-.3-.71L10.5.3z"
      fill={color}
    />
    <path
      d="M6.25 5.9l.72-1.02a.13.13 0 01.16-.03l.76.45a.5.5 0 00.66-.14L9.9 3.3a.5.5 0 10-.82-.59l-1 1.4a.13.13 0 01-.17.04l-.76-.46a.5.5 0 00-.67.14L5.46 5.28a.12.12 0 00.04.17 4 4 0 01.6.5.12.12 0 00.15-.05z"
      fill={color}
    />
  </svg>
);

export default DownloadChartSmall;
